import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("path", {
  d: "M6.99816 9.36686C2.3315 9.36686 0.464844 4.7002 0.464844 4.7002M6.99816 9.36686C11.6648 9.36686 13.5315 4.7002 13.5315 4.7002M6.99816 9.36686L6.99818 11.7002M0.93151 9.83353L2.79818 7.96686M11.1982 7.96686L13.0648 9.83353",
  stroke: "currentColor"
}, null, -1)

import VIconBase from '../VIconBase.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'ViewOffIcon',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(VIconBase, {
    name: "view-off",
    width: "14",
    height: "15",
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }))
}
}

})